// ConvoCX unified inbox — notification toasts (CON-845).
// Renders new-message notifications as accessible live-region toasts.

import { Badge, Card, Text } from '@astryxdesign/core';
import type { Message } from './types';

interface NotificationsProps {
  notifications: Message[];
  onDismiss: (id: string) => void;
}

export function Notifications({ notifications, onDismiss }: NotificationsProps) {
  const latest = notifications.slice(-4).reverse();
  if (latest.length === 0) return null;

  return (
    <div className="ccx-toasts" role="region" aria-live="polite" aria-label="Notifications" data-testid="inbox-notifications">
      {latest.map((n) => (
        <Card
          key={n.id}
          style={{ padding: 'var(--space-3) var(--space-4)', cursor: 'pointer', maxWidth: 360 }}
          onClick={() => onDismiss(n.id)}
          data-testid="inbox-notification"
        >
          <Badge label="New message" variant="info" />
          <Text type="supporting" style={{ marginTop: 4 }}>
            {n.body || 'Incoming message'}
          </Text>
        </Card>
      ))}
    </div>
  );
}